import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { XMLParser } from 'fast-xml-parser';
import { catchError, map, Observable, of, tap } from 'rxjs';

export interface BlogPost {
  title: string;
  link: string;
  guid: string;
  description: string;
  pubDate: string;
  image: string;
  author: string;
}

declare const BLOG_RSS_URL: string;

const blogRssUrl = BLOG_RSS_URL;

@Injectable({
  providedIn: 'root',
})
export class GetBlogPosts {
  private httpClient = inject(HttpClient);

  private blogPostsCache: BlogPost[] = null;

  get(limit: number): Observable<BlogPost[]> {
    if (this.blogPostsCache) {
      return of(this.blogPostsCache);
    }

    return this.httpClient.get(blogRssUrl, { responseType: 'text' }).pipe(
      map((text) => new XMLParser().parse(text)),
      map((json) => json.rss.channel.item as BlogPost[]),
      map((items) => items.slice(0, limit)),
      tap((items) => (this.blogPostsCache = items)),
      // The blog is an external, cross-origin dependency: a network, CORS or
      // abort failure must not escape as an unhandled error (see CD-1676).
      // On failure we resolve with an empty list so the section falls back to
      // its empty state, and we skip caching so the next render retries.
      catchError(() => of([] as BlogPost[])),
    );
  }
}
